var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// Initialize Swiper
var TrandingSlider = new Swiper('.tranding-slider', {
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    loop: true,
    slidesPerView: 'auto',
    coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 2.5,
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        clickable: true,
        renderFraction: function (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span> <span class="fraction-separator"></span> <span class="' + totalClass + '"></span>';
        }
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        320: { centeredSlides: true, spaceBetween: 16, slidesPerView: 2 },
        768: { centeredSlides: false, spaceBetween: 16, slidesPerView: 4 },
        1024: { centeredSlides: true, spaceBetween: 16, slidesPerView: 7 }
    }
});

// Function to handle video playback on slide change
function handleVideoPlayback() {
    var slides = TrandingSlider.slides;
    for (var i = 0; i < slides.length; i++) {
        var video = slides[i].querySelector('video');
        if (video) {
            if (i === TrandingSlider.activeIndex) {
                video.play();  // Play only active slide's video
            } else {
                video.pause();
                video.currentTime = 0; // Reset video time to start
            }
        }
    }
}

// Observe the .abz_multi_video section to trigger autoplay
var abzMultiVideo = document.querySelector('.abz_multi_video');

if (abzMultiVideo) {
    var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
            handleVideoPlayback();
        } else {
            var slides = TrandingSlider.slides;
            slides.forEach(slide => {
                var video = slide.querySelector('video');
                if (video) {
                    video.pause();
                    video.currentTime = 0;
                }
            });
        }
    }, { threshold: 0.5 });

    observer.observe(abzMultiVideo);
}

// Handle video playback on slide change
TrandingSlider.on('slideChangeTransitionEnd', handleVideoPlayback);

// Toggle mute/unmute function
function toggleMute(button) {
    var video = button.parentElement.querySelector('video');
    if (video) {
        video.muted = !video.muted;
        button.querySelector('ion-icon').setAttribute('name', video.muted ? 'volume-off-outline' : 'volume-high-outline');
    }
}